import { TYPE_NUMBER } from './input-types';

export const id = 'lineItems';
export const apiKey = 'LineItemCount';
export const type = TYPE_NUMBER;

export const lineItems = {
  id,
  apiKey,
  type,
};
